import { theme, type Types } from '@fiverr-private/theme';
import { ARROW_SIZE } from '../LightboxArrows/LightboxArrow/constants';
import { HEADER_HEIGHT } from '../LightboxHeader/constants';

export const imgVideoStylingProps: Types.GlobalStylingProps = {
    width: 'auto',
    height: 'auto',
    maxWidth: {
        default: '100%',
        sm: `calc(100vw - (${ARROW_SIZE} + ${theme.spacing['8']} + ${theme.spacing['3']}) * 2)`,
    },
    maxHeight: `calc(100vh - ${HEADER_HEIGHT} * 3)`,
};
